export default __webpack_public_path__ + "static/media/Logo YTECH.61d54857.svg";